import React from "react";
import { useLocation, useNavigate, NavLink } from "react-router-dom";
import { Box, Button, Container, Flex, HStack, Link, Show } from "@chakra-ui/react";

function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const handlePricingClick = (e) => {
    e.preventDefault();

    if (location.pathname === "/") {
      const section = document.getElementById("pricing-section");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/#pricing");
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <Box
      position="sticky"
      top="0"
      zIndex="1000"
      bg="white"
      borderBottom="1px solid"
      borderColor="gray.100"
      backdropFilter="blur(10px)"
      boxShadow="sm"
    >
      <Container maxW="7xl" py={{ base: "0.75rem", md: "1rem" }} px={{ base: 4, md: 8 }}>
        <Flex align="center" justify="space-between">
          {/* Left - Logo */}
          <Box>
            <Link
              as={NavLink}
              to="/"
              _focus={{ boxShadow: "none" }}
            >
              <img
                src="/assets/images/logo.png"
                alt="SkillBack Logo"
                width="150"
                height="50"
                style={{ display: "block", objectFit: "contain" }}
              />
            </Link>
          </Box>

          {/* Right - Links */}
          <Show above="sm">
            <HStack spacing="2rem">
              <Box position="relative">
                <Link
                  as={NavLink}
                  to="/"
                  fontWeight="500"
                  color={isActive("/") ? "blue.600" : "gray.600"}
                  _hover={{ color: "gray.900" }}
                  _focus={{ boxShadow: "none" }}
                >
                  Home
                </Link>
                {isActive("/") && (
                  <Box
                    position="absolute"
                    bottom="-8px"
                    left="0"
                    right="0"
                    h="2px"
                    bg="blue.500"
                    borderRadius="full"
                  />
                )}
              </Box>
              <Box position="relative">
                <Link
                  as={NavLink}
                  to="/why-choose-us"
                  fontWeight="500"
                  color={isActive("/why-choose-us") ? "blue.600" : "gray.600"}
                  _hover={{ color: "gray.900" }}
                  _focus={{ boxShadow: "none" }}
                >
                  Why Choose Us
                </Link>
                {isActive("/why-choose-us") && (
                  <Box
                    position="absolute"
                    bottom="-8px"
                    left="0"
                    right="0"
                    h="2px"
                    bg="blue.500"
                    borderRadius="full"
                  />
                )}
              </Box>
              <Box position="relative">
                <Link
                  as={NavLink}
                  to="/pricing"
                  fontWeight="500"
                  color={isActive("/pricing") ? "blue.600" : "gray.600"}
                  _hover={{ color: "gray.900" }}
                  _focus={{ boxShadow: "none" }}
                >
                  Pricing
                </Link>
                {isActive("/pricing") && (
                  <Box
                    position="absolute"
                    bottom="-8px"
                    left="0"
                    right="0"
                    h="2px"
                    bg="blue.500"
                    borderRadius="full"
                  />
                )}
              </Box>
              <Button
                as={NavLink}
                to="/login"
                colorScheme="blue"
                variant="outline"
                fontWeight="500"
                size="md"
                _focus={{ boxShadow: "none" }}
              >
                Sign In
              </Button>
            </HStack>
          </Show>
        </Flex>
      </Container>
    </Box>
  );
}

export default NavBar;
